<script setup lang="ts">
import { ref } from 'vue'
import MiiaFwConfig from '@/configs/config'
import image from '@/assets/img/FF_logo.png'

/**
 * @module components/miiafw/util/MiiaFwModalBase
 * @description モーダルウィンドウのスタイル定義（scoped CSS）。
 **/
// 共通ストア(Vuex)
const emit = defineEmits<{ close: []; 'push-esc': []; 'push-ctl-delete': []; 'click-close': [] }>()
const ffLogoImg = ref(image)
</script>

<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay" @click.self="emit('close')">
      <div
        class="modal-window"
        @keyup.esc.exact="emit('push-esc')"
        @keyup.ctrl.delete="emit('push-ctl-delete')"
      >
        <div class="modal-content">
          <span
            class="modal-title col-12"
            style="
              margin: 10px 0px 5px;
              padding: 0px;
              font-size: 0.7rem;
              color: #707070;
              text-align: left;
            "
          >
            <img :src="ffLogoImg" width="110px" />
            &nbsp;{{ MiiaFwConfig.config.sysName }}
            <button
              id="miiafwauthmodal-close"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="emit('click-close')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </span>
          <hr
            shade
            size="10"
            width="100%"
            color="#DCDCDC"
            style="margin-top: 0rem; margin-bottom: 2rem"
          />
          <slot></slot>
        </div>
        <footer class="modal-footer">
          <slot name="footer">
            <span class="col">©富士フイルムシステムサービス株式会社</span>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    background: #fff;
    overflow: hidden;
    width: 60%;
    max-width: 410px;
  }

  &-content {
    padding: 10px 20px;
    border-radius: 0;
  }

  &-footer {
    color: #999999;
    font-size: 0.7rem;
    background: #000000;
    padding: 8px;
    text-align: center;
    border-radius: 0;
  }
}

// オーバーレイのトランジション
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;

  // オーバーレイに包含されているモーダルウィンドウのトランジション
  .modal-window {
    transition:
      opacity 0.4s,
      transform 0.4s;
  }
}

// ディレイを付けるとモーダルウィンドウが消えた後にオーバーレイが消える
.modal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}
</style>
